module.exports = __webpack_public_path__ + "media/images/icons/flags/SZ-9ffcf5d6c012df56707952ad5ed09c3a.svg";